var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3035 4.6967C18.2324 7.62563 18.2324 12.3744 15.3035 15.3033C12.3745 18.2322 7.62579 18.2322 4.69686 15.3033C1.76792 12.3744 1.76792 7.62563 4.69686 4.6967C7.62579 1.76777 12.3745 1.76777 15.3035 4.6967ZM10.0002 14.3689C9.53992 14.3689 9.16682 13.9958 9.16682 13.5355V10.8333H6.46462C6.00438 10.8333 5.63129 10.4602 5.63129 10C5.63129 9.53976 6.00438 9.16667 6.46462 9.16667L9.16682 9.16667L9.16682 6.46447C9.16682 6.00423 9.53992 5.63113 10.0002 5.63113C10.4604 5.63113 10.8335 6.00423 10.8335 6.46447L10.8335 9.16667H13.5357C13.9959 9.16667 14.369 9.53976 14.369 10C14.369 10.4602 13.9959 10.8333 13.5357 10.8333H10.8335V13.5355C10.8335 13.9958 10.4604 14.3689 10.0002 14.3689Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInCircle);
export default __webpack_public_path__ + "static/media/PlusInCircle.25f85f2d.svg";
export { ForwardRef as ReactComponent };